module.exports = __webpack_public_path__ + "img/product_top_bg.262a5e4.png";